import React from "react";
import { AddMainProductFormActionsContext } from "./context";

export const useAddMainProductFormActionsContextProvider = () => {
  const context = React.useContext(AddMainProductFormActionsContext);
  return context;
};
